import {
  Button,
  CircularProgress,
  MenuItem,
  Paper,
  Select,
  TableContainer,
} from "@mui/material";
import moment from "moment";
import React from "react";
import { BsFillPrinterFill } from "react-icons/bs";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import useFetch from "../../hooks/useFetch";
import ReportFilter from "../table-components/filter/ReportFilter";
import Pagination from "../table-components/pagination/Pagination";
import TableComp from "../table-components/table/TableComp";
import { PdfDiv } from "./DashboardInfo.style";
import DateRangeFilter from "./DateRangeFilter";
import useProfile from "../../hooks/useProfile";

const UserReport = () => {
  const [userData] = useProfile();
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Filter: false,
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: (row) => (
          <div>{moment(row.row.original.created_at).format("DD MMM YYYY")}</div>
        ),
        Filter: DateRangeFilter,
        filter: (rows, id, filterValue) => {
          const { startDate, endDate } = filterValue || {};
          if (!startDate && !endDate) return rows;
          return rows.filter((row) => {
            const date = new Date(row.values[id]);
            return (
              (!startDate || date >= new Date(startDate)) &&
              (!endDate || date <= new Date(endDate))
            );
          });
        },
      },

      {
        Header: "Name",
        accessor: "full_name",
        Filter: false,
      },
      {
        Header: "User Name",
        accessor: "username",
        Filter: false,
      },
      {
        Header: "Email",
        accessor: "email_address",
        Filter: false,
      },
      {
        Header: "Role",
        accessor: "ugleve_name",
        Filter: false,
      },
    ],
    []
  );
  const [user, isLoading] = useFetch(
    `${process.env.REACT_APP_API_URL}/api/userList/${userData?.id}`
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: user },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "5px",
          marginBottom: "5px",
        }}
      >
        <div className="entries">
          Show Entries:{" "}
          <Select
            size="small"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            <MenuItem value={10}> 10 </MenuItem>
            <MenuItem value={user.length}> All </MenuItem>
          </Select>
        </div>
        <div>
          <ReportFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </div>
        <PdfDiv
          style={{
            display: "flex",
            gap: "5px",
          }}
        >
          <Button
            className="entries"
            onClick={() => window.print()}
            variant="outlined"
            startIcon={<BsFillPrinterFill />}
          >
            PDF Download
          </Button>
        </PdfDiv>
      </div>
      <TableContainer component={Paper}>
        <TableComp
          sortIcon="sort-icon"
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          pageIndex={pageIndex}
          prepareRow={prepareRow}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
    </>
  );
};

export default UserReport;
